export const dummyCardSport = {
  error: false,
  data: {
    list: [
      {
        authorId: 292331,
        authorName: "다스다스",
        blogId: 290440,
        blogTitle: "Miscellaneous Blog",
        blogImage: "https://t1.daumcdn.net/cfile/tistory/181AFA4F4D96D1B80D",
        blogUrl: "https://ainiesta8.tistory.com",
        entryThumbnail:
          "https://blog.kakaocdn.net/dn/bqlatf/btsD6xL9tvE/77WhYRNNYcQ5jrD4tnhj81/img.jpg",
        entryId: 2916,
        entryTitle: "빠리 쌩제르망 3",
        entryUrl: "https://ainiesta8.tistory.com/2916",
        entrySummary:
          "음바페 중앙 기용은 슬슬 포기하는 게 맞다고 한참 전부터 얘기해 왔는데 그럼에도 루쵸가 아직도 이걸 못 버리고 뭔가를 보고 싶어 하는 느낌이 가시지 않는데 개인적으로 느꼈을 때 이유는 두 가지 정도 말고는 없지 않나 싶음. 첫째는 당연히 계속해서 얘기해오고 있듯이 음바페가 애초에 볼을 길게 소유하면서 본인이 어그로를 온 더 볼로 최대한 빨아주거나 아니면 계속 여기저기 움직이면서 상대 수비수들하고 체력 싸움을 하는 것도 아니기에 공간을 내려면 결국 중요한 건 선수들 개개인의 그래비티와 상대의 수비 방식을 어느 정도 고정시켜서 적절한 타이밍에 열린 공간을 써야 한다는 거임. 문제는 처음 계획은 음바페는 무조건 측면에서 중앙으로 이동하는 동선을 짜놨는데 이것을 보조해 줄 선수들이 문제가 있다는 거고. 이 중 ..",
        serviceCategoryName: "축구",
        reactionCount: 207,
        commentCount: 49,
        entryPublished: "2024-01-29T21:36:48+09:00",
        firstReactionCreated: "2024-06-11T15:36:01.569403+09:00",
        isSupportBlog: true,
        supportCount: 4,
        supporters: [
          {
            blogImage:
              "https://t1.daumcdn.net/tistory_admin/blog/admin/profile.gif",
          },
          {
            blogImage:
              "https://t1.daumcdn.net/tistory_admin/blog/admin/profile.gif",
          },
          {
            blogImage:
              "https://t1.daumcdn.net/tistory_admin/blog/admin/profile.gif",
          },
        ],
      },
      {
        authorId: 4833775,
        authorName: "띵스띵스",
        blogId: 4647542,
        blogTitle: "오늘의 이슈 / 정보",
        blogImage:
          "https://tistory1.daumcdn.net/tistory/4647542/attach/827104db80774607ab55296eff15ac46",
        blogUrl: "https://ddingstory.tistory.com",
        entryThumbnail:
          "https://blog.kakaocdn.net/dn/OX6iB/btsHSdQLOiG/7TVsEs9apv5w1Eq6vRbU4k/img.jpg",
        entryId: 818,
        entryTitle:
          "\"쏘니, 너무 착한 거 아닌가요?\"…0-7 대패에도 손흥민 인터뷰에 '감동'한 싱가포르 팬들, '뭐라고 말했길래?‘",
        entryUrl:
          "https://ddingstory.tistory.com/entry/%EC%8F%98%EB%8B%88-%EB%84%88%EB%AC%B4-%EC%B0%A9%ED%95%9C-%EA%B1%B0-%EC%95%84%EB%8B%8C%EA%B0%80%EC%9A%94%E2%80%A60-7-%EB%8C%80%ED%8C%A8%EC%97%90%EB%8F%84-%EC%86%90%ED%9D%A5%EB%AF%BC-%EC%9D%B8%ED%84%B0%EB%B7%B0%EC%97%90-%EA%B0%90%EB%8F%99%ED%95%9C-%EC%8B%B1%EA%B0%80%ED%8F%AC%EB%A5%B4-%ED%8C%AC%EB%93%A4-%EB%AD%90%EB%9D%BC%EA%B3%A0-%EB%A7%90%ED%96%88%EA%B8%B8%EB%9E%98%E2%80%98",
        entrySummary:
          "이 인터뷰가 싱가포르에서 난리가 났다. 손흥민 인터뷰 영상이 틱톡을 통해 퍼져나갔고, 이 인터뷰를 본 많은 싱가포르 팬들이 감동을 받았다. 그리고 손흥민을 찬양했다. 너무 착하고, 너무 친절하다며 찬사를 멈추지 않았다. 손흥민이 무슨 말을 했길래. 싱가포르의 'Today'가 이 상황을 보도했다. 인터뷰를 종합하면 이렇다. https://im.newspic.kr/yrAZBbL 쏘니, 너무 착한 거 아닌가요?…0-7 대패에도 손흥민 인터뷰에 '감동'한 싱가포르 팬들, '뭐라고 [마이데일리 = 최용재 기자]한국 축구 대표팀이 대승을 거뒀다. 김도훈 감독이 이끄는 한국 대표팀은 지난 6일 싱가포르 내셔널 스타디움에서 펼쳐진 2026 북중미 월드컵 아시아 2im.newspic.kr",
        serviceCategoryName: "축구",
        reactionCount: 35,
        commentCount: 24,
        entryPublished: "2024-06-08T17:12:07+09:00",
        firstReactionCreated: "2024-06-11T15:36:01.578246+09:00",
        isSupportBlog: true,
        supportCount: 0,
        supporters: [],
      },
      {
        authorId: 3722734,
        authorName: "푸키푸키",
        blogId: 2836617,
        blogTitle: "푸키FootBall",
        blogImage:
          "https://tistory1.daumcdn.net/tistory/2836617/attach/4b682946be1541f8933b910dcfd1a773",
        blogUrl: "https://fukkifootball.tistory.com",
        entryThumbnail:
          "https://blog.kakaocdn.net/dn/uEeDa/btsHTHKc3CS/Y8RxjKFndwXkpKk3o2lMB1/img.png",
        entryId: 6902,
        entryTitle:
          "전 아스널 공격 듀오 오바메양-라카제트, 김승규 있는 알 샤밥에서 재회하나?",
        entryUrl: "https://fukkifootball.tistory.com/6902",
        entrySummary:
          "과거 아스널의 공격을 책임졌던 피에르 에메릭 오바메양과 알렉상드르 라카제트, 17-18시즌 프랑스, 독일을 대표하던 골잡이로 활약했던 이들은 런던의 붉은 유니폼을 입고 아스널의 새로운 공격 듀오로 활동하게 된다. 두 선수는 아스널에서 5시즌을 보내며 절친한 관계가 되어버렸고 이제 서로를 챙겨주며 그 어떤 선수들보다 사이가 좋았다. 이랬던 이들은 결국 아스널의 방출 대상자가 되어 아스널을 떠난 가운데 라카제트는 친정팀이었던 올림피크 리옹으로, 오바메양은 올림피크 마르세유로 이적하며 프랑스 리그 1에서 함께 활동하고 있었다. 이들은 여전히 사이좋은 모습을 보여주며 프랑스에서 경쟁을 하고 있는 가운데 프랑스 매체에서는 두 선수가 사우디아라비아로 이적할 수 있다고 보도하게 된다. 그 구단은 현재 한국 출신의 국..",
        serviceCategoryName: "축구",
        reactionCount: 31,
        commentCount: 4,
        entryPublished: "2024-06-10T11:42:43+09:00",
        firstReactionCreated: "2024-06-11T15:36:01.584057+09:00",
        isSupportBlog: true,
        supportCount: 0,
        supporters: [],
      },
    ],
    category: "sports",
    hasNext: false,
  },
};

export const dummyItemSport = {
  error: false,
  data: {
    lastPublished: 1718036581000,
    list: [
      {
        uniqueId: "2836617_6906",
        title:
          '"나폴리 주장, 배신자되나?" 디 로렌초, 라이벌 구단 유벤투스로 이적 요청',
        summary:
          "나폴리의 주장인 조반니 디 로렌초, 2019년 엠폴리를 떠나 나폴리에 합류한 그는 22-23시즌부터 주장 완장을 차기 시작하며 김민재와 함께 리그 우승을 이끈 선수 중 한 명이었다. 나폴리의 새로운 전성기 시대에 디 로렌초는 주장으로 남아 계속해서 나폴리를 책임지는 선수가 될 것으로 예상되었고 그는 지난해 2028년까지 재계약을 체결하며 나폴리 팬들을 환..",
        userId: 3722734,
        userName: "푸키푸키",
        userImage:
          "https://tistory1.daumcdn.net/tistory/2836617/attach/4b682946be1541f8933b910dcfd1a773",
        categoryName: "축구",
        thumbnail:
          "https://k.kakaocdn.net/dn/rnooU/btsHTns1xVa/Et7kPP2ZlLhcfnp3rqf57k/img.jpg",
        link: "https://fukkifootball.tistory.com/6906",
        blogId: 2836617,
        blogTitle: "푸키FootBall",
        likeCount: 6,
        commentCount: 0,
        firstReactionCreated: 1718082301000,
        published: "2024.06.11 14:04",
        publishedAgo: "1시간 전",
        supportCount: 0,
        encodedTitle:
          "%22%EB%82%98%ED%8F%B4%EB%A6%AC%20%EC%A3%BC%EC%9E%A5%2C%20%EB%B0%B0%EC%8B%A0%EC%9E%90%EB%90%98%EB%82%98%3F%22%20%EB%94%94%20%EB%A1%9C%EB%A0%8C%EC%B4%88%2C%20%EB%9D%BC%EC%9D%B4%EB%B2%8C%20%EA%B5%AC%EB%8B%A8%20%EC%9C%A0%EB%B2%A4%ED%88%AC%EC%8A%A4%EB%A1%9C%20%EC%9D%B4%EC%A0%81%20%EC%9A%94%EC%B2%AD",
        encodedUserName: "%ED%91%B8%ED%82%A4%ED%91%B8%ED%82%A4",
      },
      {
        uniqueId: "1705894_1139",
        title: "유로 2024 독일 국가대표 명단",
        summary:
          "이번주 토요일부터 개최되는 유로 2024!! 독일은 유로2024의 개최국으로써 참가한다!! 그 참가하는 멤버 발표!! 두둥!  감독율리안 나겔스만 GK올리버 바우만(호펜하임)마누엘 노이어(바이에른 뮌헨)마르크안드레 테어슈테겐(바르셀로나) DF발데마르 안톤(슈투트가르트)베냐민 헨릭스(라이프치히)요주아 키미히(바이에른 뮌헨)로빈 코흐(프랑크푸르트)막..",
        userId: 1171157,
        userName: "주지님",
        userImage: "https://t1.daumcdn.net/cfile/tistory/272AE54053DE1C3303",
        categoryName: "축구",
        thumbnail:
          "https://k.kakaocdn.net/dn/yrEew/btsHUD9sFow/LRHt6KLZS51hOsnJFCXSKk/img.webp",
        link: "https://jooji815.tistory.com/1139",
        blogId: 1705894,
        blogTitle: "사소한프로그래머의 소소한행복",
        likeCount: 20,
        commentCount: 22,
        firstReactionCreated: 1718079762000,
        published: "2024.06.11 13:22",
        publishedAgo: "2시간 전",
        supportCount: 0,
        encodedTitle:
          "%EC%9C%A0%EB%A1%9C%202024%20%EB%8F%85%EC%9D%BC%20%EA%B5%AD%EA%B0%80%EB%8C%80%ED%91%9C%20%EB%AA%85%EB%8B%A8",
        encodedUserName: "%EC%A3%BC%EC%A7%80%EB%8B%98",
      },
      {
        uniqueId: "290440_2970",
        title: "펩-바르셀로나",
        summary:
          "챔스 결승 후기는 쓰려했었는데 시기를 놓쳐서 건너뛰어버렸고. 친선 경기들은 힘 빼는 게 너무 눈에 보여서 얘기할 것들도 없고 그러다 보니 이슈를 찾으러 다니곤 있는데 딱히 쓸만한 떡밥은 없는 것 같았는데 펩 얘기가 또 나왔음.    이 블로그 자체가 바르셀로나 팬분들, 시티 팬분들 아니면 바르셀로나나 펩과 1%의 연관성이라도 있는 인물들이 있는 팀들..",
        userId: 292331,
        userName: "다스다스",
        userImage: "https://t1.daumcdn.net/cfile/tistory/181AFA4F4D96D1B80D",
        categoryName: "축구",
        thumbnail:
          "https://k.kakaocdn.net/dn/ldAOe/btsHVtkv72K/0k3VWUh6vFklbAXnTh6Wj0/img.webp",
        link: "https://ainiesta8.tistory.com/2970",
        blogId: 290440,
        blogTitle: "Miscellaneous Blog",
        likeCount: 20,
        commentCount: 8,
        firstReactionCreated: 1718067903000,
        published: "2024.06.11 10:03",
        publishedAgo: "5시간 전",
        supportCount: 0,
        encodedTitle: "%ED%8E%A9-%EB%B0%94%EB%A5%B4%EC%85%80%EB%A1%9C%EB%82%98",
        encodedUserName: "%EB%8B%A4%EC%8A%A4%EB%8B%A4%EC%8A%A4",
      },
      {
        uniqueId: "2836617_6905",
        title:
          "무리뉴-콘테의 재회할 수 있는 호이비에르, 아틀레티코까지 영입 경쟁에 뛰어들었다",
        summary:
          "2020년 8월 무리뉴 감독 체제의 토트넘에 합류하게 된 피에르 에밀 호이비에르, 사우스햄튼에서 수비형 미드필더로 존재감을 보여줬던 그는 토트넘으로 이적을 선택하게 된다. 그는 토트넘의 중원에 힘을 실어다 줄 선수로 여겨졌으며 로드리고 벤탄쿠르와 함께 중원을 책임지는 핵심 선수가 되었다. 무리뉴 감독에 이어 안토니오 콘테 감독도 호이비에르를 기..",
        userId: 3722734,
        userName: "푸키푸키",
        userImage:
          "https://tistory1.daumcdn.net/tistory/2836617/attach/4b682946be1541f8933b910dcfd1a773",
        categoryName: "축구",
        thumbnail:
          "https://k.kakaocdn.net/dn/bE2dkh/btsHUHX2wuv/9q6WVGx8s6rmNvfNmmuShk/img.png",
        link: "https://fukkifootball.tistory.com/6905",
        blogId: 2836617,
        blogTitle: "푸키FootBall",
        likeCount: 12,
        commentCount: 0,
        firstReactionCreated: 1718063636000,
        published: "2024.06.11 08:53",
        publishedAgo: "6시간 전",
        supportCount: 0,
        encodedTitle:
          "%EB%AC%B4%EB%A6%AC%EB%89%B4-%EC%BD%98%ED%85%8C%EC%9D%98%20%EC%9E%AC%ED%9A%8C%ED%95%A0%20%EC%88%98%20%EC%9E%88%EB%8A%94%20%ED%98%B8%EC%9D%B4%EB%B9%84%EC%97%90%EB%A5%B4%2C%20%EC%95%84%ED%8B%80%EB%A0%88%ED%8B%B0%EC%BD%94%EA%B9%8C%EC%A7%80%20%EC%98%81%EC%9E%85%20%EA%B2%BD%EC%9F%81%EC%97%90%20%EB%9B%B0%EC%96%B4%EB%93%A4%EC%97%88%EB%8B%A4",
        encodedUserName: "%ED%91%B8%ED%82%A4%ED%91%B8%ED%82%A4",
      },
      {
        uniqueId: "4792870_2892",
        title: "제주종합경기장 스포츠타운 구상…민자 유치 사업 타당성 논란",
        summary:
          "총사업비 7000억원 규모...면세점, 호텔 등도 조성제주도, 10일 제주도체육회관 세미나실서 용역 중간보고회 개최  제주특별자치도가 제주종합경기장 일대를 종합 스포츠타운으로 조성하기 위한 용역을 진행하는 가운데 사업 타당성에 대한 논란이 일 전망이다.제주도는 10일 오후 제주도체육회관 세미나실에서 ‘제주 종합 스포츠타운 타당성·경제성 검토 및 ..",
        userId: 4948329,
        userName: "제주일보",
        userImage:
          "https://tistory1.daumcdn.net/tistory/4792870/attach/03fcc797403041dcabed22db608e2949",
        categoryName: "스포츠일반",
        thumbnail:
          "https://k.kakaocdn.net/dn/c1b9gg/btsHVarTMQe/nKoiHCvYBvGIUm6q5MgNk1/img.jpg",
        link: "https://jejunews1945.tistory.com/2892",
        blogId: 4792870,
        blogTitle: "제주의 뉴스 한눈에 제주일보",
        likeCount: 17,
        commentCount: 8,
        firstReactionCreated: 1718063134000,
        published: "2024.06.11 08:45",
        publishedAgo: "6시간 전",
        supportCount: 0,
        encodedTitle:
          "%EC%A0%9C%EC%A3%BC%EC%A2%85%ED%95%A9%EA%B2%BD%EA%B8%B0%EC%9E%A5%20%EC%8A%A4%ED%8F%AC%EC%B8%A0%ED%83%80%EC%9A%B4%20%EA%B5%AC%EC%83%81%E2%80%A6%EB%AF%BC%EC%9E%90%20%EC%9C%A0%EC%B9%98%20%EC%82%AC%EC%97%85%20%ED%83%80%EB%8B%B9%EC%84%B1%20%EB%85%BC%EB%9E%80",
        encodedUserName: "%EC%A0%9C%EC%A3%BC%EC%9D%BC%EB%B3%B4",
      },
      {
        uniqueId: "1705894_1138",
        title: "2024 코파 아메리카!!!",
        summary:
          "2024년 코파 아메리카가 개최한다!!!! 개최지는 2년후 2026년 월드컵이 열리는 미국이다!!! 경기장  경기장은 일단 월드컵이 열릴 경기장들에서 많이 진행하는 것으로 보인다. 와 규모 장난없네................ 6만명씩 기본들어간다.. ㄷㄷㄷ (뭐 몇군데는 쩌리같지만) 본선 진출국  총 16개팀이 진출했고 각 4개조로 나누어서 8강 진출팀을 가른다. 경기일정..",
        userId: 1171157,
        userName: "주지님",
        userImage: "https://t1.daumcdn.net/cfile/tistory/272AE54053DE1C3303",
        categoryName: "축구",
        thumbnail:
          "https://k.kakaocdn.net/dn/WkqFe/btsHSUdrGLG/vk8Ko6wUT9znQekPwcfk60/img.webp",
        link: "https://jooji815.tistory.com/1138",
        blogId: 1705894,
        blogTitle: "사소한프로그래머의 소소한행복",
        likeCount: 16,
        commentCount: 18,
        firstReactionCreated: 1718062395000,
        published: "2024.06.11 08:24",
        publishedAgo: "7시간 전",
        supportCount: 0,
        encodedTitle:
          "2024%20%EC%BD%94%ED%8C%8C%20%EC%95%84%EB%A9%94%EB%A6%AC%EC%B9%B4%21%21%21",
        encodedUserName: "%EC%A3%BC%EC%A7%80%EB%8B%98",
      },
      {
        uniqueId: "6684465_374",
        title: "유명하고 충격적인 몇몇 야구 움짤들.gif",
        summary:
          '유명하고 충격적인 몇몇 야구 움짤들.gif랜디 존슨 비둘기 폭발 폭사 사건.gif랜디 존슨이 던진 공에 비둘기가 맞아 폭사하였다.구속 약 160km/h (전광판 153)해당 건은 주심이 노카운트로 처리비둘기는 털이 다빠졌지만 사체는 멀쩡했다고PETA는 랜디존슨을 동물학대혐의로 고발방송국에서 재현하려고 했지만 실패(190억분의 1의 확률이라고 함)" data-ke-type="..',
        userId: 6435540,
        userName: "cutekorean",
        userImage:
          "https://tistory1.daumcdn.net/tistory/6684465/attach/0e7c31bb2bff43d4859010265d01d52f",
        categoryName: "야구",
        thumbnail:
          "https://k.kakaocdn.net/dn/KjyPY/btsHNEs7nzg/yKSaIUONkxyhM9BzKyWEp0/img.jpg",
        link: "https://cutekorean.tistory.com/374",
        blogId: 6684465,
        blogTitle: "cutekorean",
        likeCount: 15,
        commentCount: 16,
        firstReactionCreated: 1718061828000,
        published: "2024.06.11 08:10",
        publishedAgo: "7시간 전",
        supportCount: 0,
        encodedTitle:
          "%EC%9C%A0%EB%AA%85%ED%95%98%EA%B3%A0%20%EC%B6%A9%EA%B2%A9%EC%A0%81%EC%9D%B8%20%EB%AA%87%EB%AA%87%20%EC%95%BC%EA%B5%AC%20%EC%9B%80%EC%A7%A4%EB%93%A4.gif",
        encodedUserName: "cutekorean",
      },
      {
        uniqueId: "5692194_7733535",
        title: "[골때녀] 2024 6강전",
        summary:
          "FC불나비 VS FC월드클라스 https://youtu.be/LWwHTLTJP1Y?si=1Tc-E-9u3FsL0gnw",
        userId: 5654126,
        userName: "또바기1957",
        userImage:
          "https://t1.daumcdn.net/tistory_admin/static/manage/images/r3/default_S.png",
        categoryName: "축구",
        thumbnail: null,
        link: "https://mihwang.tistory.com/entry/골때녀-2024-6강전-1",
        blogId: 5692194,
        blogTitle: "참",
        likeCount: 14,
        commentCount: 10,
        firstReactionCreated: 1718055863000,
        published: "2024.06.11 04:17",
        publishedAgo: "11시간 전",
        supportCount: 0,
        encodedTitle:
          "%5B%EA%B3%A8%EB%95%8C%EB%85%80%5D%202024%206%EA%B0%95%EC%A0%84",
        encodedUserName: "%EB%98%90%EB%B0%94%EA%B8%B01957",
      },
      {
        uniqueId: "6637092_493",
        title: "한국 vs 중국: 북중미 월드컵 아시아 예선경기 전적 및 중계 정보",
        summary:
          "6월 11일 화요일, 드디어 중국과의 두번째 북중미 월드컵 아시아 예선경기가 펼쳐집니다. 지난 2023년 11월 경기에서 많은 이슈를 남긴 만큼 이번 중국전 경기에 대한 기대감이 더욱 높아지고 있습니다.이번 글에서는 한국과 중국의 축구 관련 역대 전적 및 다양한 정보, 지난 싱가포르와의 경기 내용, 그리고 이번 한국과 중국 경기의 중계 정보, 경기 장소, 시간 등..",
        userId: 6403229,
        userName: "햇쭈",
        userImage:
          "https://tistory1.daumcdn.net/tistory/6637092/attach/2b53269a06bb40a1b084670fbf11f02f",
        categoryName: "축구",
        thumbnail:
          "https://k.kakaocdn.net/dn/2SaWy/btsHSXurtKF/XCFYfJRJ742HU7TXzickRK/img.png",
        link: "https://happyjju.com/entry/한국-vs-중국-북중미-월드컵-아시아-예선경기-전적-및-중계-정보",
        blogId: 6637092,
        blogTitle: "소소한 정보를 나누는 남자 소정남",
        likeCount: 7,
        commentCount: 3,
        firstReactionCreated: 1718054235000,
        published: "2024.06.11 06:10",
        publishedAgo: "9시간 전",
        supportCount: 0,
        encodedTitle:
          "%ED%95%9C%EA%B5%AD%20vs%20%EC%A4%91%EA%B5%AD%3A%20%EB%B6%81%EC%A4%91%EB%AF%B8%20%EC%9B%94%EB%93%9C%EC%BB%B5%20%EC%95%84%EC%8B%9C%EC%95%84%20%EC%98%88%EC%84%A0%EA%B2%BD%EA%B8%B0%20%EC%A0%84%EC%A0%81%20%EB%B0%8F%20%EC%A4%91%EA%B3%84%20%EC%A0%95%EB%B3%B4",
        encodedUserName: "%ED%96%87%EC%AD%88",
      },
      {
        uniqueId: "4558395_55",
        title:
          "6월 12일 메이저리그 승부예측 | LA다저스 vs 텍사스 레인저스 야구 경기 분석 해설 프리뷰 | 미국 MLB 승무패 언더오버 픽스터",
        summary:
          "2024년 6월 12일에 열리는 메이저리그 경기, LA 다저스와 텍사스 레인저스의 맞대결을 소개해드리겠습니다. 경기는 LA 다저스의 홈구장인 다저 스타디움에서 열리며, 한국 시간으로 오전 11시 10분에 시작됩니다. 먼저 홈팀인 LA 다저스를 살펴보겠습니다. LA 다저스는 이번 시즌 40승 24패로 내셔널 리그 ..",
        userId: 3809600,
        userName: "다크몬",
        userImage:
          "https://tistory1.daumcdn.net/tistory/4558395/attach/2de23e18e41f4c73bc7d733f722d3f7f",
        categoryName: "야구",
        thumbnail:
          "https://k.kakaocdn.net/dn/Wd1qO/btsHTGFx6n3/DpXqwkynpNMwvsFFRFXKPk/img.jpg",
        link: "https://darkdaily.tistory.com/55",
        blogId: 4558395,
        blogTitle: "다크데일리",
        likeCount: 19,
        commentCount: 12,
        firstReactionCreated: 1718036650000,
        published: "2024.06.11 01:19",
        publishedAgo: "오늘",
        supportCount: 0,
        encodedTitle:
          "6%EC%9B%94%2012%EC%9D%BC%20%EB%A9%94%EC%9D%B4%EC%A0%80%EB%A6%AC%EA%B7%B8%20%EC%8A%B9%EB%B6%80%EC%98%88%EC%B8%A1%20%7C%20LA%EB%8B%A4%EC%A0%80%EC%8A%A4%20vs%20%ED%85%8D%EC%82%AC%EC%8A%A4%20%EB%A0%88%EC%9D%B8%EC%A0%80%EC%8A%A4%20%EC%95%BC%EA%B5%AC%20%EA%B2%BD%EA%B8%B0%20%EB%B6%84%EC%84%9D%20%ED%95%B4%EC%84%A4%20%ED%94%84%EB%A6%AC%EB%B7%B0%20%7C%20%EB%AF%B8%EA%B5%AD%20MLB%20%EC%8A%B9%EB%AC%B4%ED%8C%A8%20%EC%96%B8%EB%8D%94%EC%98%A4%EB%B2%84%20%ED%94%BD%EC%8A%A4%ED%84%B0",
        encodedUserName: "%EB%8B%A4%ED%81%AC%EB%AA%AC",
      },
      {
        uniqueId: "4558395_54",
        title:
          "6월 12일 메이저리그 승부예측 | 샌프란시스코 자이언츠 vs 휴스턴 애스토로스 경기 분석 해설 | 미국 야구 MLB 승1패 언더오버 픽스터",
        summary:
          "2024년 6월 12일에 열리는 메이저리그 경기, 샌프란시스코 자이언츠와 휴스턴 애스트로스의 맞대결에 대해 소개해드리겠습니다. 경기는 샌프란시스코 자이언츠의 홈구장인 오라클 파크에서 열리며, 한국 시간으로 오전 10시 45분에 시작됩니다. 먼저 홈팀인 샌프란시스코 자이언츠를 살펴보겠습니다. 샌프란시스코 ..",
        userId: 3809600,
        userName: "다크몬",
        userImage:
          "https://tistory1.daumcdn.net/tistory/4558395/attach/2de23e18e41f4c73bc7d733f722d3f7f",
        categoryName: "야구",
        thumbnail:
          "https://k.kakaocdn.net/dn/biTTDw/btsHSWWzrNx/6Ht9rk1GkE9QDUBbOKhzGk/img.jpg",
        link: "https://darkdaily.tistory.com/54",
        blogId: 4558395,
        blogTitle: "다크데일리",
        likeCount: 19,
        commentCount: 12,
        firstReactionCreated: 1718036619000,
        published: "2024.06.11 01:18",
        publishedAgo: "오늘",
        supportCount: 0,
        encodedTitle:
          "6%EC%9B%94%2012%EC%9D%BC%20%EB%A9%94%EC%9D%B4%EC%A0%80%EB%A6%AC%EA%B7%B8%20%EC%8A%B9%EB%B6%80%EC%98%88%EC%B8%A1%20%7C%20%EC%83%8C%ED%94%84%EB%9E%80%EC%8B%9C%EC%8A%A4%EC%BD%94%20%EC%9E%90%EC%9D%B4%EC%96%B8%EC%B8%A0%20vs%20%ED%9C%B4%EC%8A%A4%ED%84%B4%20%EC%95%A0%EC%8A%A4%ED%86%A0%EB%A1%9C%EC%8A%A4%20%EA%B2%BD%EA%B8%B0%20%EB%B6%84%EC%84%9D%20%ED%95%B4%EC%84%A4%20%7C%20%EB%AF%B8%EA%B5%AD%20%EC%95%BC%EA%B5%AC%20MLB%20%EC%8A%B91%ED%8C%A8%20%EC%96%B8%EB%8D%94%EC%98%A4%EB%B2%84%20%ED%94%BD%EC%8A%A4%ED%84%B0",
        encodedUserName: "%EB%8B%A4%ED%81%AC%EB%AA%AC",
      },
      {
        uniqueId: "4558395_53",
        title:
          "6월 12일 메이저리그 승부예측 | 시애틀 매리너스 vs 시카고 화이트삭스 경기 분석 해설 프리뷰 | 미국 MLB 야구 승1패 언더오버 픽스터",
        summary:
          "2024년 6월 12일에 열리는 메이저리그 경기, 시애틀 매리너스와 시카고 화이트삭스의 경기를 소개해드리겠습니다. 경기는 시애틀 매리너스의 홈구장인 T-모바일 파크에서 열리며, 한국 시간으로 오전 10시 40분에 시작됩니다. 먼저 홈팀인 시애틀 매리너스를 살펴보겠습니다. 시애틀 매리너스는 이번 시즌 37승 ..",
        userId: 3809600,
        userName: "다크몬",
        userImage:
          "https://tistory1.daumcdn.net/tistory/4558395/attach/2de23e18e41f4c73bc7d733f722d3f7f",
        categoryName: "야구",
        thumbnail:
          "https://k.kakaocdn.net/dn/ALP43/btsHTVbA1ix/JWJANI9ND14n45PgCyRCik/img.jpg",
        link: "https://darkdaily.tistory.com/53",
        blogId: 4558395,
        blogTitle: "다크데일리",
        likeCount: 19,
        commentCount: 12,
        firstReactionCreated: 1718036581000,
        published: "2024.06.11 01:16",
        publishedAgo: "오늘",
        supportCount: 0,
        encodedTitle:
          "6%EC%9B%94%2012%EC%9D%BC%20%EB%A9%94%EC%9D%B4%EC%A0%80%EB%A6%AC%EA%B7%B8%20%EC%8A%B9%EB%B6%80%EC%98%88%EC%B8%A1%20%7C%20%EC%8B%9C%EC%95%A0%ED%8B%80%20%EB%A7%A4%EB%A6%AC%EB%84%88%EC%8A%A4%20vs%20%EC%8B%9C%EC%B9%B4%EA%B3%A0%20%ED%99%94%EC%9D%B4%ED%8A%B8%EC%82%AD%EC%8A%A4%20%EA%B2%BD%EA%B8%B0%20%EB%B6%84%EC%84%9D%20%ED%95%B4%EC%84%A4%20%ED%94%84%EB%A6%AC%EB%B7%B0%20%7C%20%EB%AF%B8%EA%B5%AD%20MLB%20%EC%95%BC%EA%B5%AC%20%EC%8A%B91%ED%8C%A8%20%EC%96%B8%EB%8D%94%EC%98%A4%EB%B2%84%20%ED%94%BD%EC%8A%A4%ED%84%B0",
        encodedUserName: "%EB%8B%A4%ED%81%AC%EB%AA%AC",
      },
    ],
    category: "sports",
    hasNext: true,
  },
};



export const dummyItemSport2 = {
  "error": false,
  "data": {
    "lastPublished": 1718868831000,
    "list": [
      {
        "uniqueId": "6924422_210",
        "title": "2024 K리그 파니니 축구 카드 구매 방법 및 후기",
        "summary": "블로그 다른 글 보기 머무르기    K리그 파니니 카드지난해 출시하여 150만팩 이상의 판매 신화를 쓴 'K리그 파니니 카드' 가 2024년 버전으로 새롭게 출시하였습니다.세븐일레븐에서 구매할 수 있는데요.  베이직 카드 175장과 스페셜 카드 95장으로 총 270장으로 구성 되어 지난해에 비해 더 종류가 다양해졌습니다. 또한, 지난해에는 K리그1 선수들만 구..",
        "userId": 5513121,
        "userName": "dynamic_grampus",
        "userImage": "https://tistory1.daumcdn.net/tistory/6924422/attach/b23f36b7ec6b472b9c8cca39c3e6428f",
        "categoryName": "축구",
        "thumbnail": "https://k.kakaocdn.net/dn/Sgc6E/btsH5Mljf6Y/HInh7TqRH363nS6UkH8qlk/img.jpg",
        "link": "https://dynamicgrampus.com/entry/2024-K리그-파니니-축구-카드-구매-방법-및-후기",
        "blogId": 6924422,
        "blogTitle": "dynamic_grampus",
        "likeCount": 5,
        "commentCount": 0,
        "firstReactionCreated": 1718883098000,
        "published": "2024.06.20 16:12",
        "publishedAgo": "5시간 전",
        "supportCount": 0,
        "encodedTitle": "2024%20K%EB%A6%AC%EA%B7%B8%20%ED%8C%8C%EB%8B%88%EB%8B%88%20%EC%B6%95%EA%B5%AC%20%EC%B9%B4%EB%93%9C%20%EA%B5%AC%EB%A7%A4%20%EB%B0%A9%EB%B2%95%20%EB%B0%8F%20%ED%9B%84%EA%B8%B0",
        "encodedUserName": "dynamic_grampus"
      },
      {
        "uniqueId": "7055170_157",
        "title": "KBO이야기_NC다이노스_손아섭 KBO최다안타(2,505안타)",
        "summary": "손아섭선수는 6. 20 두산과의 경기에서 4회초 알칸타라선수를 상대로한국프로야구 통산 최다 안타(2,505안타)를 기록했다. (▼ 손아섭선수 2,500안타 달성 포스팅)https://sunrisepark1984.tistory.com/132 KBO이야기_NC다이노스_손아섭 2500안타역대급 흥행몰이를 하는 가운데NC다이노스소속의 손아섭선수가 2024년 6월 15일 삼성과의  경기에서이승현 선..",
        "userId": 6664257,
        "userName": "넥벤져스1984",
        "userImage": "https://tistory1.daumcdn.net/tistory/7055170/attach/bec69d14619148e5b3b77f62bac10ffb",
        "categoryName": "야구",
        "thumbnail": "https://k.kakaocdn.net/dn/crzcZM/btsH4b0qMbs/d8PXN9ewVKVDkcPnhZ6EP1/img.png",
        "link": "https://sunrisepark1984.tistory.com/157",
        "blogId": 7055170,
        "blogTitle": "야구와 게임을 좋아하는 평범한 직장인이야기",
        "likeCount": 10,
        "commentCount": 3,
        "firstReactionCreated": 1718882069000,
        "published": "2024.06.20 20:14",
        "publishedAgo": "1시간 전",
        "supportCount": 0,
        "encodedTitle": "KBO%EC%9D%B4%EC%95%BC%EA%B8%B0_NC%EB%8B%A4%EC%9D%B4%EB%85%B8%EC%8A%A4_%EC%86%90%EC%95%84%EC%84%AD%20KBO%EC%B5%9C%EB%8B%A4%EC%95%88%ED%83%80%282%2C505%EC%95%88%ED%83%80%29",
        "encodedUserName": "%EB%84%A5%EB%B2%A4%EC%A0%B8%EC%8A%A41984"
      },
      {
        "uniqueId": "3885876_342",
        "title": "유로 2024 조별리그 D조의 운명을 가를 대결: 2024년 6월 26일 프랑스 대 폴란드 경기 일정, 전력 비교, 선수 명단 및 하이라이트 분석",
        "summary": "유럽 축구의 최강자를 가리는 UEFA 유로 2024 조별리그의 열기가 뜨겁습니다. 특히 축구 팬들의 관심을 집중시키는 D조의 마지막 경기, 프랑스 대 폴란드의 경기는 누가 16강으로 진출하게 될지에 대한 흥미진진한 승부가 될 것으로 예상됩니다. 본 글에서는 그 누구도 놓치고 싶지 않은 이 역사적인 경기의 일정, 중계 방법, 두 팀의 전력 비교, 선수 명단, 그리고 ..",
        "userId": 4366321,
        "userName": "꿈꾸는블로그왕",
        "userImage": "https://tistory1.daumcdn.net/tistory/3885876/attach/9b571b34b8ee4a81a35feb2ae3243a69",
        "categoryName": "축구",
        "thumbnail": "https://k.kakaocdn.net/dn/pBHyZ/btsH5xbj0cA/kJwr0QAaQ67oLqNBF6WNP1/img.png",
        "link": "https://android-dev.tistory.com/342",
        "blogId": 3885876,
        "blogTitle": "기리's A to Z",
        "likeCount": 18,
        "commentCount": 19,
        "firstReactionCreated": 1718881303000,
        "published": "2024.06.20 20:00",
        "publishedAgo": "1시간 전",
        "supportCount": 0,
        "encodedTitle": "%EC%9C%A0%EB%A1%9C%202024%20%EC%A1%B0%EB%B3%84%EB%A6%AC%EA%B7%B8%20D%EC%A1%B0%EC%9D%98%20%EC%9A%B4%EB%AA%85%EC%9D%84%20%EA%B0%80%EB%A5%BC%20%EB%8C%80%EA%B2%B0%3A%202024%EB%85%84%206%EC%9B%94%2026%EC%9D%BC%20%ED%94%84%EB%9E%91%EC%8A%A4%20%EB%8C%80%20%ED%8F%B4%EB%9E%80%EB%93%9C%20%EA%B2%BD%EA%B8%B0%20%EC%9D%BC%EC%A0%95%2C%20%EC%A0%84%EB%A0%A5%20%EB%B9%84%EA%B5%90%2C%20%EC%84%A0%EC%88%98%20%EB%AA%85%EB%8B%A8%20%EB%B0%8F%20%ED%95%98%EC%9D%B4%EB%9D%BC%EC%9D%B4%ED%8A%B8%20%EB%B6%84%EC%84%9D",
        "encodedUserName": "%EA%BF%88%EA%BE%B8%EB%8A%94%EB%B8%94%EB%A1%9C%EA%B7%B8%EC%99%95"
      },
      {
        "uniqueId": "290440_2983",
        "title": "시나리오 나오는데",
        "summary": "4개월 전에 파우스가 오로지 의장으로만 바르셀로나 복귀에 관심 있다고 뜬 이후로 라포르타 행보가 뭔가 굉장히 급해 보이는 게 우연은 아닌 거 같다고 느낌. 이건 두 가지로 해석할 수 있겠죠. 현지에서 라포르타 민심이 로메우 급이다. 와 파우스가 의장 선거에 나오는 게 생각보다 거부감이 강하지 않아 충분히 가능성 있는 얘기다. 물론 두 가지 다 양립할 수 있..",
        "userId": 292331,
        "userName": "다스다스",
        "userImage": "https://t1.daumcdn.net/cfile/tistory/181AFA4F4D96D1B80D",
        "categoryName": "축구",
        "thumbnail": "https://k.kakaocdn.net/dn/bx9GMh/btsH6wPVAR5/0gjwm3IOZcYKbxjonrwDKK/img.webp",
        "link": "https://ainiesta8.tistory.com/2983",
        "blogId": 290440,
        "blogTitle": "Miscellaneous Blog",
        "likeCount": 26,
        "commentCount": 4,
        "firstReactionCreated": 1718876707000,
        "published": "2024.06.20 18:26",
        "publishedAgo": "2시간 전",
        "supportCount": 0,
        "encodedTitle": "%EC%8B%9C%EB%82%98%EB%A6%AC%EC%98%A4%20%EB%82%98%EC%98%A4%EB%8A%94%EB%8D%B0",
        "encodedUserName": "%EB%8B%A4%EC%8A%A4%EB%8B%A4%EC%8A%A4"
      },
      {
        "uniqueId": "6858061_817",
        "title": "샌디에이고 밀워키 MLB 메이저리그 중계 무료 시청 바로가기",
        "summary": "지난 시즌 내셔널리그 중부지구 우승을 차지한 밀워키 부루어스는 올 시즌에도 좋은 모습을 보이며 42승 29패로 선두권을 달리고 있습니다. 한편 샌디에이고 파드리스는 37승 38패로 다소 부진한 성적을 내고 있지만, 타선의 화력은 여전히 뛰어납니다. 두 팀 모두 포스트시즌 진출을 노리고 있는 만큼, 이번 맞대결의 결과가 시리즈 전체 분위기를 좌우할 것으로 ..",
        "userId": 6543597,
        "userName": "친절한 아무개씨",
        "userImage": "https://tistory1.daumcdn.net/tistory/6858061/attach/00fc08c3e7c84d7ebdebf97611fe4099",
        "categoryName": "야구",
        "thumbnail": "https://k.kakaocdn.net/dn/cgA2Lk/btsH60QwpGU/Rnpl1arVNoEoK6aY9DfHYk/img.jpg",
        "link": "https://small-joy.tistory.com/817",
        "blogId": 6858061,
        "blogTitle": "불가근불가원",
        "likeCount": 7,
        "commentCount": 9,
        "firstReactionCreated": 1718874137000,
        "published": "2024.06.20 17:55",
        "publishedAgo": "3시간 전",
        "supportCount": 0,
        "encodedTitle": "%EC%83%8C%EB%94%94%EC%97%90%EC%9D%B4%EA%B3%A0%20%EB%B0%80%EC%9B%8C%ED%82%A4%20MLB%20%EB%A9%94%EC%9D%B4%EC%A0%80%EB%A6%AC%EA%B7%B8%20%EC%A4%91%EA%B3%84%20%EB%AC%B4%EB%A3%8C%20%EC%8B%9C%EC%B2%AD%20%EB%B0%94%EB%A1%9C%EA%B0%80%EA%B8%B0",
        "encodedUserName": "%EC%B9%9C%EC%A0%88%ED%95%9C%20%EC%95%84%EB%AC%B4%EA%B0%9C%EC%94%A8"
      },
      {
        "uniqueId": "6782731_224",
        "title": "유로 2024 F조 순위, 결과 및 골 장면 하이라이트 움짤 (gif)",
        "summary": "F조 순위표순위팀경기승무패득점실점득차승점1튀르키예1100312 2포르투갈1100211 3체코100112-1 4조지아100113-2  F조 경기, 결과, 득점자6월 19일 수요일튀르키예 3 : 1 조지아 포르투갈 2 : 1 체코",
        "userId": 6233256,
        "userName": "에코메아리",
        "userImage": "https://tistory1.daumcdn.net/tistory/6782731/attach/b98c3fa2fa78464f87bec915263fa2d8",
        "categoryName": "축구",
        "thumbnail": "https://k.kakaocdn.net/dn/bYyYh7/btsH5jqHh2E/9wG2GOUbRPtyTqX3IyzUr1/img.png",
        "link": "https://ecoechoes.tistory.com/224",
        "blogId": 6782731,
        "blogTitle": "EcoEchoes",
        "likeCount": 15,
        "commentCount": 18,
        "firstReactionCreated": 1718872828000,
        "published": "2024.06.20 17:40",
        "publishedAgo": "3시간 전",
        "supportCount": 0,
        "encodedTitle": "%EC%9C%A0%EB%A1%9C%202024%20F%EC%A1%B0%20%EC%88%9C%EC%9C%84%2C%20%EA%B2%B0%EA%B3%BC%20%EB%B0%8F%20%EA%B3%A8%20%EC%9E%A5%EB%A9%B4%20%ED%95%98%EC%9D%B4%EB%9D%BC%EC%9D%B4%ED%8A%B8%20%EC%9B%80%EC%A7%A4%20%28gif%29",
        "encodedUserName": "%EC%97%90%EC%BD%94%EB%A9%94%EC%95%84%EB%A6%AC"
      },
      {
        "uniqueId": "6782731_223",
        "title": "유로 2024 E조 순위, 결과 및 골 장면 하이라이트 움짤 (gif)",
        "summary": "E조 순위표순위팀경기승무패득점실점득차승점1루마니아110030332슬로바키아110010133벨기에100101-104우크라이나100103-30 E조 경기, 결과, 득점자6월 17일월요일벨기에 0 : 1 슬로바키아루마니아 3 : 0 우크라이나",
        "userId": 6233256,
        "userName": "에코메아리",
        "userImage": "https://tistory1.daumcdn.net/tistory/6782731/attach/b98c3fa2fa78464f87bec915263fa2d8",
        "categoryName": "축구",
        "thumbnail": "https://k.kakaocdn.net/dn/yRJad/btsH6LTx2iI/eP6QS5PnTF6xVOMCsa1sdk/img.png",
        "link": "https://ecoechoes.tistory.com/223",
        "blogId": 6782731,
        "blogTitle": "EcoEchoes",
        "likeCount": 12,
        "commentCount": 13,
        "firstReactionCreated": 1718872295000,
        "published": "2024.06.20 17:28",
        "publishedAgo": "3시간 전",
        "supportCount": 0,
        "encodedTitle": "%EC%9C%A0%EB%A1%9C%202024%20E%EC%A1%B0%20%EC%88%9C%EC%9C%84%2C%20%EA%B2%B0%EA%B3%BC%20%EB%B0%8F%20%EA%B3%A8%20%EC%9E%A5%EB%A9%B4%20%ED%95%98%EC%9D%B4%EB%9D%BC%EC%9D%B4%ED%8A%B8%20%EC%9B%80%EC%A7%A4%20%28gif%29",
        "encodedUserName": "%EC%97%90%EC%BD%94%EB%A9%94%EC%95%84%EB%A6%AC"
      },
      {
        "uniqueId": "6782731_222",
        "title": "유로 2024 D조 순위, 결과 및 골 장면 하이라이트 움짤 (gif)",
        "summary": "D조 순위표순위팀경기승무패득점실점득차승점1네덜란드110021132프랑스110010133폴란드100112-104오스트리아100101-10 C조 경기, 결과, 득점자6월 16일 일요일폴란드 1 : 2 네덜란드 오스트리아 0 : 1 프랑스",
        "userId": 6233256,
        "userName": "에코메아리",
        "userImage": "https://tistory1.daumcdn.net/tistory/6782731/attach/b98c3fa2fa78464f87bec915263fa2d8",
        "categoryName": "축구",
        "thumbnail": "https://k.kakaocdn.net/dn/YjEYV/btsH6v4s7vd/JH0qnUOxts5xO0VNTcekoK/img.png",
        "link": "https://ecoechoes.tistory.com/222",
        "blogId": 6782731,
        "blogTitle": "EcoEchoes",
        "likeCount": 11,
        "commentCount": 12,
        "firstReactionCreated": 1718871717000,
        "published": "2024.06.20 17:15",
        "publishedAgo": "4시간 전",
        "supportCount": 0,
        "encodedTitle": "%EC%9C%A0%EB%A1%9C%202024%20D%EC%A1%B0%20%EC%88%9C%EC%9C%84%2C%20%EA%B2%B0%EA%B3%BC%20%EB%B0%8F%20%EA%B3%A8%20%EC%9E%A5%EB%A9%B4%20%ED%95%98%EC%9D%B4%EB%9D%BC%EC%9D%B4%ED%8A%B8%20%EC%9B%80%EC%A7%A4%20%28gif%29",
        "encodedUserName": "%EC%97%90%EC%BD%94%EB%A9%94%EC%95%84%EB%A6%AC"
      },
      {
        "uniqueId": "6782731_221",
        "title": "유로 2024 C조 순위, 결과 및 골 장면 하이라이트 움짤(gif)",
        "summary": "C조 순위표순위팀경기승무패득점실점득차승점1잉글랜드110011132덴마크101011013슬로베니아101011014세르비아100101-10 C조 경기, 결과, 득점자6월 16일 일요일슬로베니아 1 : 1 덴마크세르비아 0 : 1 잉글랜드",
        "userId": 6233256,
        "userName": "에코메아리",
        "userImage": "https://tistory1.daumcdn.net/tistory/6782731/attach/b98c3fa2fa78464f87bec915263fa2d8",
        "categoryName": "축구",
        "thumbnail": "https://k.kakaocdn.net/dn/bFMqdD/btsH5dYeARO/14zdJ6r6VqUxGvlYXhJ1CK/img.png",
        "link": "https://ecoechoes.tistory.com/221",
        "blogId": 6782731,
        "blogTitle": "EcoEchoes",
        "likeCount": 12,
        "commentCount": 14,
        "firstReactionCreated": 1718870922000,
        "published": "2024.06.20 16:57",
        "publishedAgo": "4시간 전",
        "supportCount": 0,
        "encodedTitle": "%EC%9C%A0%EB%A1%9C%202024%20C%EC%A1%B0%20%EC%88%9C%EC%9C%84%2C%20%EA%B2%B0%EA%B3%BC%20%EB%B0%8F%20%EA%B3%A8%20%EC%9E%A5%EB%A9%B4%20%ED%95%98%EC%9D%B4%EB%9D%BC%EC%9D%B4%ED%8A%B8%20%EC%9B%80%EC%A7%A4%28gif%29",
        "encodedUserName": "%EC%97%90%EC%BD%94%EB%A9%94%EC%95%84%EB%A6%AC"
      },
      {
        "uniqueId": "2836617_6930",
        "title": "토트넘이 버린 은돔벨레, 프랑스 구단들에게 관심받으며 리그 1 복귀 유력",
        "summary": "2019년 토트넘은 올림피크 리옹 소속이었던 탕기 은돔벨레 영입에 957억이라는 거금을 사용하며 클럽 레코드를 달성했었다. 은돔벨레는 토트넘의 리그 우승의 시발점이자 토트넘의 이적시장이 달라졌다는 것을 보여주는 시발점이었으며 탈압박이 능숙한 그의 합류로 인해 토트넘의 중원은 더욱 강해질 것 같았다. 토트넘을 전성기로 이끌었던 마우리시오 포체..",
        "userId": 3722734,
        "userName": "푸키푸키",
        "userImage": "https://tistory1.daumcdn.net/tistory/2836617/attach/4b682946be1541f8933b910dcfd1a773",
        "categoryName": "축구",
        "thumbnail": "https://k.kakaocdn.net/dn/bg74z4/btsH5JCgDzk/ZiOqsSpIfmYNbtDnXDkIrk/img.png",
        "link": "https://fukkifootball.tistory.com/6930",
        "blogId": 2836617,
        "blogTitle": "푸키FootBall",
        "likeCount": 15,
        "commentCount": 0,
        "firstReactionCreated": 1718869625000,
        "published": "2024.06.20 16:46",
        "publishedAgo": "4시간 전",
        "supportCount": 0,
        "encodedTitle": "%ED%86%A0%ED%8A%B8%EB%84%98%EC%9D%B4%20%EB%B2%84%EB%A6%B0%20%EC%9D%80%EB%8F%94%EB%B2%A8%EB%A0%88%2C%20%ED%94%84%EB%9E%91%EC%8A%A4%20%EA%B5%AC%EB%8B%A8%EB%93%A4%EC%97%90%EA%B2%8C%20%EA%B4%80%EC%8B%AC%EB%B0%9B%EC%9C%BC%EB%A9%B0%20%EB%A6%AC%EA%B7%B8%201%20%EB%B3%B5%EA%B7%80%20%EC%9C%A0%EB%A0%A5",
        "encodedUserName": "%ED%91%B8%ED%82%A4%ED%91%B8%ED%82%A4"
      },
      {
        "uniqueId": "6782731_220",
        "title": "유로 2024 B조 순위, 결과 및 골 장면 하이라이트 (gif)",
        "summary": "B조 순위표순위팀경기승무패득점실점득실차승점1잉글랜드110011132덴마크101011013슬로베니아101011014세르비아100101-10 B조 경기, 결과, 득점자 6월 15일 토요일스페인3 : 0 크로아티아이탈리아1 : 0 알바니아",
        "userId": 6233256,
        "userName": "에코메아리",
        "userImage": "https://tistory1.daumcdn.net/tistory/6782731/attach/b98c3fa2fa78464f87bec915263fa2d8",
        "categoryName": "축구",
        "thumbnail": "https://k.kakaocdn.net/dn/tECwi/btsH5NEGV0l/O7FuQE7BMnGkBL6TK3tGS0/img.png",
        "link": "https://ecoechoes.tistory.com/220",
        "blogId": 6782731,
        "blogTitle": "EcoEchoes",
        "likeCount": 13,
        "commentCount": 14,
        "firstReactionCreated": 1718869586000,
        "published": "2024.06.20 16:45",
        "publishedAgo": "4시간 전",
        "supportCount": 0,
        "encodedTitle": "%EC%9C%A0%EB%A1%9C%202024%20B%EC%A1%B0%20%EC%88%9C%EC%9C%84%2C%20%EA%B2%B0%EA%B3%BC%20%EB%B0%8F%20%EA%B3%A8%20%EC%9E%A5%EB%A9%B4%20%ED%95%98%EC%9D%B4%EB%9D%BC%EC%9D%B4%ED%8A%B8%20%28gif%29",
        "encodedUserName": "%EC%97%90%EC%BD%94%EB%A9%94%EC%95%84%EB%A6%AC"
      },
      {
        "uniqueId": "6782731_219",
        "title": "유로 2024 A조 순위, 결과 및 골 장면 하이라이트 (gif)",
        "summary": "A조 순위표순위팀경기승무패득점실점득실차승점1독일220071662스위스211042243스코틀랜드201126-414헝가리200215-40  A조 경기, 결과, 득점자 6월 14일 금요일독일5 : 1스위스독일 (비르츠 10', 무시알라 19', 하베르츠 45'+1 (페널티), 퓔크루크 68', 찬 90'+3) 5-1스코틀랜드 (뤼디거 87' 자책골) 6월 15일 토요일 헝가리1 : 3스위스헝가리 (바르가 66') 스..",
        "userId": 6233256,
        "userName": "에코메아리",
        "userImage": "https://tistory1.daumcdn.net/tistory/6782731/attach/b98c3fa2fa78464f87bec915263fa2d8",
        "categoryName": "축구",
        "thumbnail": "https://k.kakaocdn.net/dn/bA4tIa/btsH6O3Lr0p/w9wVikvUKF5BHfa9pRlFZ0/img.png",
        "link": "https://ecoechoes.tistory.com/219",
        "blogId": 6782731,
        "blogTitle": "EcoEchoes",
        "likeCount": 11,
        "commentCount": 12,
        "firstReactionCreated": 1718868831000,
        "published": "2024.06.20 16:28",
        "publishedAgo": "4시간 전",
        "supportCount": 0,
        "encodedTitle": "%EC%9C%A0%EB%A1%9C%202024%20A%EC%A1%B0%20%EC%88%9C%EC%9C%84%2C%20%EA%B2%B0%EA%B3%BC%20%EB%B0%8F%20%EA%B3%A8%20%EC%9E%A5%EB%A9%B4%20%ED%95%98%EC%9D%B4%EB%9D%BC%EC%9D%B4%ED%8A%B8%20%28gif%29",
        "encodedUserName": "%EC%97%90%EC%BD%94%EB%A9%94%EC%95%84%EB%A6%AC"
      }
    ],
    "category": "sports",
    "hasNext": true
  }
}